import { Badge } from '@/components/ui/Badge';
import {
  TICKET_PRIORITY_LABEL,
  TICKET_PRIORITY_TONE,
  TICKET_STATUS_LABEL,
  TICKET_STATUS_TONE,
} from '@/constants/support';
import type { TicketPriority, TicketStatus } from '@/types/support';

/** Where a ticket stands, in the same words and colour on both panels. */
export function TicketStatusBadge({ status }: { status: TicketStatus }) {
  return (
    <Badge tone={TICKET_STATUS_TONE[status]} withDot>
      {TICKET_STATUS_LABEL[status]}
    </Badge>
  );
}

/**
 * How urgent. Low and Normal are not drawn at all in a list — they are the
 * usual case, and a column of grey "Normal" pills is noise around the two that
 * matter. Pass `always` where the value itself is being read.
 */
export function TicketPriorityBadge({
  priority,
  always = false,
}: {
  priority: TicketPriority;
  always?: boolean;
}) {
  if (!always && (priority === 'LOW' || priority === 'NORMAL')) return null;
  return <Badge tone={TICKET_PRIORITY_TONE[priority]}>{TICKET_PRIORITY_LABEL[priority]}</Badge>;
}
